import React, { createContext, useContext, useState } from 'react';

export interface AddEditFormActions {
  openDeleteModal: () => void;
  isEditContact: boolean;
}

interface AddEditFormActionsContextValue {
  actions: AddEditFormActions | null;
  setActions: React.Dispatch<React.SetStateAction<AddEditFormActions | null>>;
}

const AddEditFormActionsContext = createContext<AddEditFormActionsContextValue | null>(null);

export const AddEditFormActionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [actions, setActions] = useState<AddEditFormActions | null>(null);
  return (
    <AddEditFormActionsContext.Provider value={{ actions, setActions }}>
      {children}
    </AddEditFormActionsContext.Provider>
  );
};

export const useAddEditFormActions = (): AddEditFormActionsContextValue | null => {
  return useContext(AddEditFormActionsContext);
};
